<script setup>
import PageHeader from '@/layout/PageHeader.vue';
import PageContainer from '@/layout/PageContainer.vue';
import CookieBanner from '@/component/CookieBanner.vue';
import store from '@/store';

store.dispatch('getLoginInfo');
store.dispatch('getAppPolicy');
store.dispatch('getCookieStatement');
</script>
<template>
  <div class="h-screen background">
    <page-header></page-header>
    <page-container></page-container>
    <CookieBanner></CookieBanner>
  </div>
</template>
<style scoped>
@media screen and (min-width: 640px) {
  .background {
    background-color: rgb(243, 244, 246);
  }
}
</style>
